export default localStorage;